import { render, staticRenderFns } from "./main-filter-component-new.vue?vue&type=template&id=99a91d72&scoped=true"
import script from "./main-filter-component-new.vue?vue&type=script&lang=js"
export * from "./main-filter-component-new.vue?vue&type=script&lang=js"
import style0 from "./main-filter-component-new.vue?vue&type=style&index=0&id=99a91d72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a91d72",
  null
  
)

export default component.exports